import PropTypes from "prop-types";
import AlertMessage from "app/components/ui/AlertMessage/AlertMessage";
import { ALERT_TYPE } from "app/constants";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

const USAWarningMessage = ({ showWarning, className }) => {
	if (!showWarning) {
		return null;
	}

	return (
		<AlertMessage
			alertType={ALERT_TYPE.INFO}
			className={classNames("warning-usa-destination", className)}
			message={<FormattedMessage id="general.warning.adult.destination.usa" />}
		/>
	);
};

USAWarningMessage.propTypes = {
	showWarning: PropTypes.bool.isRequired,
};

export default USAWarningMessage;
